import EventListingSection from "../../components/Events/EventListingSection";
import Page from "../../finwell/pages/Page";
import MenuCoaching from "../../components/MenuCoaching";

const ProviderEventsPage = () => {

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const providerId = params.get('provider_id');

  return (
    <Page>
      <MenuCoaching 
        providerId={providerId} 
        selectedItem={3}
        showBanner={false}
      />
      <EventListingSection />
    </Page>

  )


}

export default ProviderEventsPage;